import { render } from "./PopupPromoVideo.vue?vue&type=template&id=7da491be&scoped=true"
import script from "./PopupPromoVideo.vue?vue&type=script&lang=js"
export * from "./PopupPromoVideo.vue?vue&type=script&lang=js"

import "./PopupPromoVideo.vue?vue&type=style&index=0&id=7da491be&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da491be"]])

export default __exports__